export default __webpack_public_path__ + "static/media/moscowSport-desktop.58934123.png";